import { Box, Divider, MenuItem, Select, IconButton as MuiIconButton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { translate } from "../services";
import { FirstPage, LastPage, NavigateBefore, NavigateNext } from "@mui/icons-material";

const Pagination = (props)=>{

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const isInitialMount = useRef(true);

    useEffect(()=>{
      setProductsPerPage();
    },[props.pageresult.results])

    useEffect(()=>{
      if(isInitialMount.current){
        isInitialMount.current = false;
      }
      else{
        props.callNextPage && props.callNextPage(page, rowsPerPage);
      }    
    },[page, rowsPerPage])

    const setProductsPerPage = ()=>{
        console.log(page, rowsPerPage)
        const { pageresult } = props;
        let { results } = pageresult;

        let products = results;

        let startIndex = (page)*rowsPerPage;
        let lastIndex = startIndex+rowsPerPage;

        products = products.filter((p)=>{return p.tableIndex>=startIndex && p.tableIndex<lastIndex});

        products.sort((a,b)=>a.tableIndex-b.tableIndex);

        if(props.fromConfiguratorSelector){
          products = products.map(product=> {return {...product, ["hideConfigureButton"]:true}})
        }
        console.log(startIndex, lastIndex, products)
        props.setProductsPerPage(products)
      }

    const displayActionBar = ()=>{
        const { pageresult } = props;
        let { results } = pageresult;
        let products = results;
        let startIndex = (page)*rowsPerPage;
        let lastIndex = startIndex+rowsPerPage;
        
        products = products.filter((p)=>{return p.tableIndex>=startIndex && p.tableIndex<lastIndex});

        products.sort((a,b)=>a.tableIndex-b.tableIndex);

        lastIndex = products[products.length-1]?products[products.length-1].tableIndex:lastIndex;

        return <span className='pagination-footer'>{`${translate("Showing")} ${startIndex+1}-${lastIndex+1} ${translate("of")} ${pageresult.totalItems}`}</span>
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0)
      };
    
    const handleChangePage = (event, newPage, flag) => {
        console.log(newPage)
        setPage(newPage)
      };


      const {pageresult} = props;
      let { results } = pageresult;

      let productsData = results;
      let startIndex = (page)*rowsPerPage;
      let lastIndex = startIndex+rowsPerPage;
      let productData = productsData;

      if(pageresult.totalItems<=10){
        return;
      }
    return (
        <Box className="product-footer-container" width="100%" height= "15%" display="flex" justifyContent="start" alignItems="center" sx={{backgroundColor:"#FFFFFF", borderTop: "1px solid #EBEBEB", paddingX:"48px", minHeight:"55px"}}  >
    <Box width="200px" height="50%" display="flex" flexDirection="row" justifyContent="start" alignItems="center">
    <span className='pagination-footer'>{translate("Rows Per Page:")}</span>
    <Select value={rowsPerPage} 
    className='current-row-font'
    autoWidth 
    height="100%" 
    onChange={handleChangeRowsPerPage}
    // BackdropProps = {sx=}
    sx={{ boxShadow: 'none',  boxShadow: "none",
    "&.MuiModal-backdrop":{background:"transparent !important"},
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
      {
        border: 0,
      },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
      {
        border: 0,
      }, ml:"9px" }}
      MenuProps={{
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        PaperProps: {
          sx: {
            borderRadius:"0px",
            left:"290px",
            bgcolor: 'white',
            '& .Mui-selected': {
              backgroundColor: 'white !important',
              fontWeight: 700,
            },
          },
        }
      }}
      >
      <MenuItem value={30}>
        <div className={rowsPerPage === 30 ? 'active-page-number': 'inactive-page-number'}>
          <span className={`page-number-of-rows` + (rowsPerPage === 30 ? ` active-current-row`: '')} style={{fontSize:"14px"}}>30</span>
          {/* <Box sx={{width:"26px", height:"1px", background: "#DBDBDB"}}></Box> */}
        </div>    
      </MenuItem>
      <Divider variant='middle' sx={{width:"26px", height:"1px", mt:"0px !important", mb:"0px !important"}}></Divider>
      <MenuItem value={20}>
        <div className={rowsPerPage === 20 ? 'active-page-number': 'inactive-page-number'}>
          <span className={`page-number-of-rows` + (rowsPerPage === 20 ? ` active-current-row`: '')} style={{fontSize:"14px"}}>20</span>
          {/* <Box sx={{width:"26px", height:"1px", background: "#DBDBDB"}}></Box> */}
        </div>
      </MenuItem>
      <Divider variant='middle' sx={{width:"26px", height:"1px", mt:"0px !important", mb:"0px !important"}}></Divider>
      <MenuItem value={10}> 
      <div className={rowsPerPage === 10 ? 'active-page-number': 'inactive-page-number'}>
        <span className={`page-number-of-rows` + (rowsPerPage === 10 ? ` active-current-row`: '')} style={{fontSize:"14px"}}>10</span>
      </div>
      </MenuItem>
    </Select>
  </Box>
  <Box flexGrow={1} />
    <div className='action-bar' >
      {displayActionBar()}
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={page===0} onClick={(e)=>{handleChangePage(e,0)}}><FirstPage></FirstPage></MuiIconButton> 
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={page===0} onClick={(e)=>{handleChangePage(e,page-1)}}><NavigateBefore></NavigateBefore></MuiIconButton>
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={
        lastIndex+1>pageresult.totalItems} 
        onClick={(e)=>{handleChangePage(e,page+1)}}><NavigateNext></NavigateNext></MuiIconButton>
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple disabled={lastIndex+1>pageresult.totalItems}  onClick={(e)=>{
        handleChangePage(e,Math.ceil((pageresult.totalItems/rowsPerPage)-1), true)}}><LastPage></LastPage></MuiIconButton>
    </div>
    </Box>
    )

}

export default Pagination;